var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.overide === 'link' &&
    (_vm.url.startsWith('https://') || _vm.url.startsWith('mailto'))
  )?_c('a',{class:_vm.style,attrs:{"target":"_blank","href":_vm.url}},[_c('SvgIcon',{class:_vm.iconStyleOveride,attrs:{"title":_vm.title,"name":_vm.icon}})],1):(_vm.overide === 'link' && !_vm.url.startsWith('https://'))?_c('NuxtLink',{class:_vm.style,attrs:{"to":_vm.url}},[_c('SvgIcon',{attrs:{"title":_vm.title,"name":_vm.icon}})],1):_c('button',{class:_vm.style},[_c('SvgIcon',{class:_vm.iconStyleOveride,attrs:{"title":_vm.title,"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }